/**
 * Handles state of price snapshots
 */
import { ADD_PRICE_CHANGE, MERGE_PRICE_CHANGES } from '../actions/price_changes';

interface IPriceObject {
  address: string;
  chain: string;
  price_a: number;
  price_a_usd: number;
  price_b: number;
  price_b_usd: number;
}

export interface IPriceChangesState {
  [key: string]: IPriceObject;
}

const priceChangesReducer = (state = {}, action: any) => {
  switch (action.type) {
  case ADD_PRICE_CHANGE:
    return {
      ...state,
      [action.payload.key]: action.payload.data,
    };
  case MERGE_PRICE_CHANGES:
    return {
      ...state,
      ...action.payload
    };
  default:
    return state;
  }
};

export default priceChangesReducer;
